import { buildUrl } from 'domain/Api';
import { ApiCall, createApiActionCreator } from 'omni-common-ui';

const DISABLE_DEFAULT_ACTION_EXTRAS = { disableDefault: true };

const ACTION_OBJECT_NAME = 'CIC_CATEGORIES';

export const FETCH_CIC_CATEGORIES_REQUEST = `FETCH_${ACTION_OBJECT_NAME}_REQUEST`;
export const FETCH_CIC_CATEGORIES_SUCCESS = `FETCH_${ACTION_OBJECT_NAME}_SUCCESS`;
export const FETCH_CIC_CATEGORIES_FAILURE = `FETCH_${ACTION_OBJECT_NAME}_FAILURE`;

const buildCICCategoriesURL = (groupId) => buildUrl(`/groups/${groupId}/cic-category`);

export function fetchCICCategoriesIfNeeded(groupId) {
  return (dispatch, getState) => {
    const state = getState();
    if (! ApiCall.shouldPerform(state, { method: 'GET', url: buildCICCategoriesURL(groupId) })) {
      return false;
    }
    return dispatch(fetchCICCategories(groupId));
  };
}

export function fetchCICCategories(groupId) {
  return createApiActionCreator(
    ACTION_OBJECT_NAME,
    buildCICCategoriesURL(groupId),
    'GET',
    DISABLE_DEFAULT_ACTION_EXTRAS,
    { groupId },
  );
}



// WEBPACK FOOTER //
// ./data/CoveredInClass/CategoryTemplate/actions.js